import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { logout, dropout, changeField } from '../../modules/account';
import { addKakaoChannel, handleLogout } from '../../utils/nativeApi';
import DrawerTemplate from '../../components/drawer/drawer/DrawerTemplate';
import CouponsTemplate from '../../components/drawer/drawer/CouponsTemplate';
import logEvent from '../../utils/logEvent';
import { KEY } from '../../utils/constants/storageKey';

import { getValidCouponList } from 'modules/user';
import { setPageTitle } from '../../modules/status';
import { requestOpenBrowser } from 'utils/nativeApi';

const DrawerContainer = ({ history, location }) => {
  const [dropoutState, setDropoutState] = useState(false);
  const [logoutState, setLogoutState] = useState(false);
  const { t } = useTranslation('drawer');

  const dispatch = useDispatch();
  const { activeUser, autoLogin, language, authType, coupons } = useSelector(
    ({ account, user, status }) => ({
      autoLogin: account.login.autoLogin,
      activeUser: user && user.users ? user.users[0] : null,
      language: status.language,
      authType: account.account?.auth_type,
      coupons: user.coupons,
    }),
  );
  useEffect(() => {
    logEvent({ page: 'drawer' });
    location.pathname === '/drawer/coupons' &&
      dispatch(setPageTitle(t('availableCoupons')));
  }, [location]);

  // 데이터 페치하기
  useEffect(() => {
    activeUser && coupons.length === 0 && dispatch(getValidCouponList());
  }, []);

  const onLogout = () => {
    setLogoutState(logoutState ? false : true);
  };
  const onLogoutConfirm = () => {
    handleLogout();
    dispatch(logout()); // 브라우저 스토리지에 저장된 계정 정보 삭제
  };
  const onDropout = () => {
    setDropoutState(dropoutState ? false : true);
  };
  const onDropoutConfirm = () => {
    dispatch(dropout());
  };
  const onShowVersion = () => {
    history.push('/version');
  };
  const onAutoLogin = () => {
    if (autoLogin) {
      const accountFromLocal = localStorage.getItem(KEY);
      localStorage.removeItem(KEY);
      sessionStorage.setItem(KEY, accountFromLocal);
    } else {
      const accountFromSession = sessionStorage.getItem(KEY);
      sessionStorage.removeItem(KEY);
      localStorage.setItem(KEY, accountFromSession);
    }
    dispatch(
      changeField({
        form: 'login',
        key: 'autoLogin',
        value: !autoLogin,
      }),
    );
  };

  const openProductListBrowser = () => {
    requestOpenBrowser(
      process.env.REACT_APP_SERVER_BASE_URL === 'stg'
        ? 'http://becon-homepage-stg-temporary.s3-website.ap-northeast-2.amazonaws.com/product-list'
        : 'https://www.withbecon.com/product-list',
    );
  };

  return (
    <>
      {location.pathname === '/drawer' && (
        <DrawerTemplate
          activeUser={activeUser}
          onCloseDrawer={() => history.goBack()}
          onShowVersion={onShowVersion}
          onAutoLogin={onAutoLogin}
          autoLogin={autoLogin}
          logoutState={logoutState}
          onLogout={onLogout}
          onLogoutConfirm={onLogoutConfirm}
          dropoutState={dropoutState}
          onDropout={onDropout}
          onDropoutConfirm={onDropoutConfirm}
          onAddKakaoChannel={addKakaoChannel}
          language={language}
          authType={authType}
          onClickCoupons={() => history.push('/drawer/coupons')}
        />
      )}
      {location.pathname === '/drawer/coupons' && (
        <CouponsTemplate
          coupons={coupons}
          onClickBtn={openProductListBrowser}
        />
      )}
    </>
  );
};

export default withRouter(DrawerContainer);
